<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>数据统计</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="freashRent">手动更细订单总金额与租金</el-button>
                </el-col>
            </el-row>
    
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-danger">
                        <h3>昨日新用户数</h3>
                        <h6>{{fetch.lastUserNum}}</h6>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-info">
                        <h3>昨日成功订单数</h3>
                        <h6>{{fetch.lastSuccessOrder}}</h6>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-warning">
                        <h3>过去一个月注册用户数</h3>
                        <h6>{{fetch.monthRegister}}</h6>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-success">
                        <h3>过去一个月支付订单数</h3>
                        <h6>{{fetch.monthSuccessOrder}}</h6>
                    </div>
                </el-col>
            </el-row>
    
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <h3>累计获的租金</h3>
                        <h6>{{fetch.rentalSum}}</h6>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <h3>上架商品总数</h3>
                        <h6>{{fetch.onlineProduct}}</h6>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <h3>过去一个月获的租金</h3>
                        <h6>{{fetch.monthRental}}</h6>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <h3>已芝麻绑定用户数</h3>
                        <h6>{{fetch.zmUserNum}}</h6>
                    </div>
                </el-col>
            </el-row>
    
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="demo-color-box bg-info">
                        待发货订单
                        <div class="value">{{fetch.orderUnderDeliver}}</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="demo-color-box bg-silver">
                        待返还确认订单
                        <div class="value">{{fetch.orderUnderReturn}}</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="demo-color-box bg-warning">
                        未付款订单数
                        <div class="value">{{fetch.orderUnderPay}}</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="demo-color-box bg-success">
                        待返还订单
                        <div class="value">{{fetch.orderDelivered}}</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="demo-color-box bg-danger">
                        订单总金额
                        <div class="value">{{fetch.orderPayMount}}</div>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span style="line-height: 36px;">租赁次数前10的商品</span>
                        </div>
                        <div v-for="(o,i) in fetch.rentalCountTopProducts" :key="i" class="text item">
                            {{++i}}、{{o.name }}
                        </div>
                    </el-card>
                </el-col>

                <el-col :span="12">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span style="line-height: 36px;">累计租金最高的前10商品</span>
                        </div>
                        <div v-for="(o,i) in fetch.rentalSumTopProducts" :key="i" class="text item">
                            {{++i}}、{{o.name }}
                        </div>
                    </el-card>
                </el-col>
            </el-row>
    
    
        </div>
    
    </div>
</template>

<script>
    import {
        getTongji,
        getFreashOrder
    } from '../../api/version'
    
    export default {
        data() {
            return {
                fetch: {}
            }
        },
        created() {
            getTongji(sessionStorage.userId).then(res => {
                this.fetch = res.data
            })
        },
        methods: {

            freashRent() {
                getFreashOrder(sessionStorage.userId).then( res => {
                    console.log(res.data)
                    if(res.data) {
                        getTongji(sessionStorage.userId).then(res => {
                            this.fetch = res.data
                        })
                        this.$message({
                            type: 'success',
                            message: '更新成功!'
                        });

                    }
                })
            }
    
        }
    }
</script>

<style scoped>
    .el-row {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }

    h6 {
        font-size: 18px;
    }

    .value {
        font-size: 18px;
    }
    
    .bg-blue,
    .bg-info {
        background-color: #20a0ff;
        color: #fff;
    }
    
    .bg-success {
        background-color: #13ce66;
        color: #fff;
    }
    
    .bg-warning {
        background-color: #f7ba2a;
        color: #fff;
    }
    
    .bg-silver {
        background-color: #8492a6;
        color: #fff;
    }
    
    .bg-danger {
        background-color: #ff4949;
        color: #fff;
    }
    
    .demo-color-box {
        border-radius: 4px;
        padding: 20px;
        height: 74px;
        box-sizing: border-box;
        color: #fff;
        font-size: 14px;
    }
    
    .el-col {
        border-radius: 4px;
    }
    
    .bg-purple-dark {
        background: #99a9bf;
    }
    
    .bg-purple {
        background: #d3dce6;
    }
    
    .bg-purple-light {
        background: #e5e9f2;
    }
    
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
</style>




// WEBPACK FOOTER //
// GetStatistics.vue?41da53a6